import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import { useStore } from 'vuex'
import {
  amazonGet
} from '@/apis/inShipping'
import { ElMessage } from 'element-plus'

export default (form: any) => {
  const store = useStore()
  const getProductSkuList = async (val: never[]) => {
    console.log('val', val)
    const list = (val || []).map((e: any) => ({ ...e, deliveryNums: e.useable }))
    const amazonSkuList = [...new Set(list.filter(v => v.amazonMsku).map(v => v.amazonMsku))]
    if (amazonSkuList.length) {
      const { data } = await amazonGet({
        amazonSkuList,
        customerShopId: store.getters.curShop
      })
      list.forEach((item, index) => {
        const findItem = data.find((v:any) => (v.amazonMsku === item.amazonMsku) && item.amazonMsku)
        if (findItem) {
          list[index] = {
            ...item,
            prepCategory: findItem.prepCategory,
            isValid: findItem.isValid,
            prepOwnerConstraint: findItem.prepOwnerConstraint,
            labelOwnerConstraint: findItem.labelOwnerConstraint
          }
        }
      })
    }
    form.replenishPlanItemList = form.replenishPlanItemList.concat(list)
  }

  const addProductVisible = ref(false)
  const openAddProductVisible = () => {
    addProductVisible.value = true
  }

  const STableRef = ref()

  const productSelection = ref([])
  const handleSelection = (val: any) => {
    productSelection.value = val
  }

  const delMoreRow = () => {
    productSelection.value.forEach((p: any) => {
      const idx = form.replenishPlanItemList.findIndex((e: any) => e.productSku === p.productSku)
      form.replenishPlanItemList.splice(idx, 1)
    })
    STableRef.value.clearSelection()
  }
  const delRow = (productSku: any) => {
    const idx = form.replenishPlanItemList.findIndex((e: any) => e.productSku === productSku)
    form.replenishPlanItemList.splice(idx, 1)
    STableRef.value.clearSelection()
  }

  return {
    STableRef,
    getProductSkuList,
    addProductVisible,
    openAddProductVisible,
    handleSelection,
    delMoreRow,
    delRow
  }
}
